import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {monthlyInternalCost_template} from "../components/templates/monthlyInternalCost_template";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class monthlyInternalCost extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected monthlyInternalCost_template: monthlyInternalCost_template;

    START_YEAR: number = 2020;
    END_YEAR: number = 2030;

    //
    // implementation of base class [vnModule]
    protected getModuleName(): string {

        return "monthlyInternalCost";
    }

    //
    // implementation of base class [vnModule]
    buildContent(): Array<Element> {

        this.monthlyInternalCost_template = new monthlyInternalCost_template("monthlyInternalCost_template", this.viewModel, this)
        return [this.monthlyInternalCost_template.build()];
    }

    public fillPage() : void{

        this.getListFormData();
    }

    public goHome(): void {
        page.redirect('/');
    }

    public getPiLoggedId(): number {

        let vnApp = this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn) {
            return vnApp.loggedUser.user.id;
        }

        return null;
    }

    protected getListFormData(): void{

        this.loadingIn(this.monthlyInternalCost_template.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.monthlyInternalCost_template.getViewModelForRequest();

        let usrReq_url: string = '/api/internal_cost/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFiltersDataReturn;
        this.XHRHdl.execute();
    }

    protected onFiltersDataReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.monthlyInternalCost_template.validationsList.clearMessages();
                obj.setFilters(response);
                obj.getListData();
            });
        }
    }

    protected getListData(): void {
        this.loadingIn(this.monthlyInternalCost_template.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.monthlyInternalCost_template.getViewModelForRequest();

        let usrReq_url: string = '/api/internal_cost/get';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterListDataReturn;
        this.XHRHdl.execute();
    }

    protected onFilterListDataReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.monthlyInternalCost_template.setYears(response.years);
                obj.monthlyInternalCost_template.setCostData(response.data);

            });

            obj.loadingOut(obj.monthlyInternalCost_template.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateUsersFilter(): void {
        this.loadingIn(this.monthlyInternalCost_template.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.monthlyInternalCost_template.getViewModelForRequest();

        let usrReq_url: string = '/api/internal_cost/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterUsersListDataReturn;
        this.XHRHdl.execute();
    }

    protected onFilterUsersListDataReturn(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.setUsersFilter(response.users);
                obj.getListData();

            });
        }
    }

    protected save(){

        this.loadingIn(this.monthlyInternalCost_template.builtTemplate.children.namedItem("list-results"));

        let formReq_url: string = '/api/internal_cost/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.monthlyInternalCost_template.getViewModelForPostRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = this.onPostMonthlyCostData
        XHRHdl.execute();
    }

    private onPostMonthlyCostData(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.getListData();
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, response.message);

            });
            obj.loadingOut(obj.monthlyInternalCost_template.builtTemplate.children.namedItem("list-results"));

        }
    }

    protected filterDropdownOnChange(): void {

        this.updateUsersFilter();
    }

    // data setters on template
    // set filters.
    protected setFilters(responseData): void {

        this.setBrandsFilter(responseData['brands']);
        this.setUsersFilter(responseData['users']);
    }

    protected setBrandsFilter(brands): void {

        this.monthlyInternalCost_template.setBrands(brands);
    }

    // set templates filter
    protected setUsersFilter(users): void {

        this.monthlyInternalCost_template.setUsers(users);
    }

}


// WEBPACK FOOTER //
// ./js/modules/monthlyInternalCost.ts